(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TransactionAsyncTask', TransactionAsyncTask);

    TransactionAsyncTask.$inject = ['$resource', 'DateUtils'];

    function TransactionAsyncTask ($resource, DateUtils) {
        var resourceUrl =  'api/transaction-async-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.nextCheckDate = DateUtils.convertDateTimeFromServer(data.nextCheckDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
